import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 340px;
  margin-bottom: 20px;
  border-radius: 2.1613px;
  overflow: hidden;
  
  @media (max-width: 760px) {
    width: 100%;
  }
`;

export const ProductImage = styled.div`
  display: flex;
  width: 340px;
  height: 150px;
  background-size: cover;  
  flex-direction: column;
  
  background-image: url('${(p) => p.imageUrl}');
  cursor: pointer;

  @media (max-width: 760px) {
    width: 100%;
  }
`;

export const ProductFuncoes = styled.div`
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 15.6%, rgba(0, 0, 0, 0.52) 53.45%);
  width: 340px;
  height: 150px;
  color: white;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 100px;
  padding-left: 10px;
  padding-right: 10px;

  @media (max-width: 760px) {
    width: 100%;
  }
`;
export const ProductInformation = styled.div`
  width: 150px;
  font-weight: 700;
  font-size: 18px;
  line-height: 20px;
  color: #FFFFFF;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;

  
`;

export const ProductButton = styled.button`
  height: 20.56px;
  width: 88.26px;
  background: #E40A3B;
  border: 0.801541px solid #FFFFFF;
  border-radius: 24.8478px;
  border-style: none;
  font-weight: 700;
  margin-top: 22px;
`;
